import StatisticalReportTable from './StatisticalReportTable'
export default StatisticalReportTable
